import { csx } from '@vtex/admin-ui'

export const styles = {
  alertContainer: csx({
    background: '$secondary',
    paddingY: '$space-2',
    paddingX: '$space-3',
    borderRadius: 4,
    border: '$neutral',
    display: 'flex',
    alignItems: 'center',
    gap: '$space-3',
  }),
  iconBox: csx({
    display: 'flex',
    padding: '0.625rem',
    background: '#1D1D1D0D',
    color: '$secondary',
    borderRadius: 4,
  }),
  content: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-6',
  }),
}
